export function isEkPackage(pkg) {
  return Boolean(pkg?.is_ek_package) || String(pkg?.slug || '').startsWith('ek_');
}

export function isTekSorguPackage(pkg) {
  const slug = String(pkg?.slug || '').toLowerCase();
  const name = String(pkg?.pricing_display_name || pkg?.name || '').toLowerCase();
  return slug.includes('teksorgu') || slug === 'ek_baslangic' || name.includes('tek sorgu');
}

/** /accounts/pricing/ ile aynı üç grup. */
export function groupLandingPackages(packages) {
  const list = Array.isArray(packages) ? packages : [];
  const ek = list.filter((pkg) => isEkPackage(pkg));
  const rest = list.filter((pkg) => !isEkPackage(pkg));
  const monthly = rest.filter((pkg) => Number(pkg.duration_months) === 1);
  const yearly = rest.filter((pkg) => Number(pkg.duration_months) >= 12);
  const tekFirst = [...ek].sort((a, b) => {
    const aTek = isTekSorguPackage(a) ? 0 : 1;
    const bTek = isTekSorguPackage(b) ? 0 : 1;
    return aTek - bTek;
  });
  return { monthly, yearly, ek: tekFirst };
}
